module.exports = __webpack_public_path__ + "img/full3-min.fe2a7884.png";